'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _reactReduxToastr = require('react-redux-toastr');

var _strings = require('helpers/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customToastr = {};

var isArgsWithOptions = function isArgsWithOptions(args) {
  return (0, _typeof3.default)(args[args.length - 1]) === 'object';
};

function bindArgs(args) {
  var t = require('i18n-universal').getT();
  var defaultOpts = {
    showCloseButton: true,
    timeOut: 4000,
    transitionIn: 'fadeIn',
    transitionOut: 'fadeOut',
    okText: t('OK'),
    cancelText: t('Cancel'),
    progressBar: false
  };

  if (isArgsWithOptions(args)) {
    args[args.length - 1] = (0, _extends3.default)({}, defaultOpts, args[args.length - 1]);
  } else {
    args.push(defaultOpts);
  }

  return args;
}

['success', 'info', 'warning', 'error', 'message', 'confirm'].map(function (method) {
  customToastr[method] = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // add default title
    if (method !== 'confirm') {
      if (args.length === 1 || isArgsWithOptions(args) && args.length < 3) {
        var _t = require('i18n-universal').getT();
        args.unshift(_t((0, _strings.capitalize)(method)));
      }
    }
    return _reactReduxToastr.toastr[method].apply(_reactReduxToastr.toastr, (0, _toConsumableArray3.default)(bindArgs(args)));
  };
});

exports.default = customToastr;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/toastr.js
// module id = 25
// module chunks = 1